"use strict";

require("core-js/modules/es6.object.assign");

function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}

function wrap(e, t, a, r) {
  return "in" in e && (e.when = e.in), _react2.default.Children.count(r) < 2 ? _react2.default.createElement(_RevealBase2.default, _extends({}, e, {
    inEffect: t,
    outEffect: a,
    children: r
  })) : (r = _react2.default.Children.map(r, function (r) {
    return _react2.default.createElement(_RevealBase2.default, _extends({}, e, {
      inEffect: t,
      outEffect: a,
      children: r
    }));
  }), "Fragment" in _react2.default ? _react2.default.createElement(_react2.default.Fragment, null, r) : _react2.default.createElement("span", null, r));
}

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var _extends = Object.assign || function (e) {
  for (var t = 1; t < arguments.length; t++) {
    var a = arguments[t];

    for (var r in a) {
      Object.prototype.hasOwnProperty.call(a, r) && (e[r] = a[r]);
    }
  }

  return e;
};

exports.default = wrap;

var _react = require("react"),
    _react2 = _interopRequireDefault(_react),
    _RevealBase = require("./RevealBase"),
    _RevealBase2 = _interopRequireDefault(_RevealBase);

module.exports = exports.default;